import { injectIntl } from "react-intl";
import { formatNumber } from "src/helpers/formatNumber";

const formatLargeNumber = (value) => (value ?? 0).toLocaleString();

const MetricCards = ({ metrics }) => {
  return (
    <div className="SmsAnalyticsMetricRow">
      <div className="SmsAnalyticsMetricCard">
        <div className="SmsAnalyticsMetricCardTop">
          <div className="SmsAnalyticsMetricLabel">Net Profit</div>
          <div className="SmsAnalyticsMetricIconPurple">
            <img
              alt=""
              src="/media/icons/currency-dollar-purple.svg"
              className="w-4 h-4"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 items-start self-stretch">
          <div className="SmsAnalyticsMetricValue">
            ${formatNumber(metrics?.netProfit)}
          </div>
          <div className="SmsAnalyticsMetricSub">Revenue minus cost</div>
        </div>
      </div>

      <div className="SmsAnalyticsMetricCard">
        <div className="SmsAnalyticsMetricCardTop">
          <div className="SmsAnalyticsMetricLabel">Overall ROI</div>
          <div className="SmsAnalyticsMetricIconPurple">
            <img
              alt=""
              src="/media/icons/trend-up-01.svg"
              className="w-4 h-4"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 items-start self-stretch">
          <div className="SmsAnalyticsMetricValue text-[#743FE4]">
            {formatNumber(metrics?.overallRoi)}%
          </div>
          <div className="SmsAnalyticsMetricSub">Return on spend</div>
        </div>
      </div>

      <div className="SmsAnalyticsMetricCard">
        <div className="SmsAnalyticsMetricCardTop">
          <div className="SmsAnalyticsMetricLabel">Revenue / Cost</div>
          <div className="SmsAnalyticsMetricIconGray">
            <img
              alt=""
              src="/media/icons/currency-dollar.svg"
              className="w-4 h-4"
            />
          </div>
        </div>
        <div className="SmsAnalyticsRevenueCostRow">
          <div>
            <div className="SmsAnalyticsMetricSub">Total Rev</div>
            <div className="SmsAnalyticsMetricValueSmall">
              ${formatNumber(metrics?.totalRevenue)}
            </div>
          </div>
          <div className="SmsAnalyticsMetricDivider" />
          <div>
            <div className="SmsAnalyticsMetricSub">Total Cost</div>
            <div className="SmsAnalyticsMetricValueSmall">
              ${formatNumber(Math.abs(metrics?.totalCost ?? 0))}
            </div>
          </div>
        </div>
      </div>

      <div className="SmsAnalyticsMetricCard">
        <div className="SmsAnalyticsMetricCardTop">
          <div>
            <div className="SmsAnalyticsMetricLabel">Volume Metrics</div>
          </div>
          <div className="SmsAnalyticsMetricIconGray">
            <img
              alt=""
              src="/media/icons/message-square-01.svg"
              className="w-4 h-4"
            />
          </div>
        </div>
        <div className="SmsAnalyticsVolumeGrid">
          <div className="SmsAnalyticsVolumeItem">
            <span className="SmsAnalyticsMetricSub">Messages</span>
            <span className="SmsAnalyticsVolumeValue">
              {formatLargeNumber(metrics?.totalMessages)}
            </span>
          </div>
          <div className="SmsAnalyticsVolumeItem">
            <span className="SmsAnalyticsMetricSub">Conversions</span>
            <span className="SmsAnalyticsVolumeValue">
              {formatLargeNumber(metrics?.totalConversions)}
            </span>
          </div>
          <div className="SmsAnalyticsVolumeItem">
            <span className="SmsAnalyticsMetricSub">EPU (Rev / Msg)</span>
            <span className="SmsAnalyticsVolumeValue">
              ${formatNumber(metrics?.EPU ?? 0)}
            </span>
          </div>
          <div className="SmsAnalyticsVolumeItem">
            <span className="SmsAnalyticsMetricSub">Rev per 1k (RPM)</span>
            <span className="SmsAnalyticsVolumeValue">
              ${formatNumber(metrics?.RPM ?? 0)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(MetricCards);
